module.exports = __webpack_public_path__ + "img/hoslogo2.822dffad.png";